import React from 'react';
import PropTypes from 'prop-types';
import ButtonGroup from '@material-ui/core/ButtonGroup';
import Button from 'Components/UI/Button';
import { Schedule } from '@material-ui/icons';
import { FDTooltip } from '@facet-wealth/design';

function ScheduleButtonWithGeneratedContent({
  resource,
  onClickSend,
  onClickSchedule,
}) {
  const scheduleButtonDisabled = resource.isTruthy('isSameAsGeneratedContent');

  return (
    <FDTooltip title={resource.attr('sendHelperText')} placement="top">
      <ButtonGroup variant="contained">
        <Button
          color="secondary"
          disableElevation
          onClick={onClickSend}
          variant="contained"
          disabled={scheduleButtonDisabled}
        >
          {resource.attr('sendLabel')}
        </Button>
        <Button
          color="secondary"
          disableElevation
          onClick={onClickSchedule}
          variant="contained"
          disabled={scheduleButtonDisabled}
          test="schedule-agenda-button"
        >
          <Schedule fontSize="small" />
        </Button>
      </ButtonGroup>
    </FDTooltip>
  );
}

ScheduleButtonWithGeneratedContent.defaultProps = {
};

ScheduleButtonWithGeneratedContent.propTypes = {
  resource: PropTypes.object.isRequired,
  onClickSend: PropTypes.func.isRequired,
  onClickSchedule: PropTypes.func.isRequired,
};

ScheduleButtonWithGeneratedContent.defaultProps = {
};

export default ScheduleButtonWithGeneratedContent;
